
import React from 'react';
import { Belt } from './types';

interface BeltCirclesProps {
  belts: Belt[];
  baseBeltSpacing: number;
  stripeSpacings: number[];
  onBeltClick?: (belt: Belt) => void;
}

export const BeltCircles: React.FC<BeltCirclesProps> = ({ 
  belts, 
  baseBeltSpacing, 
  stripeSpacings, 
  onBeltClick 
}) => {
  // Get belt position based on the cumulative stripe spacings
  const getBeltPosition = (index: number): number => {
    const startX = 40; // Starting X position
    
    // If this is the first belt, it's at the starting position
    if (index === 0) return startX;
    
    // Otherwise, calculate position based on cumulative stripeSpacings
    let position = startX;
    
    // Add all previous belt sections (each belt has 5 segments - the belt itself + 4 stripes)
    for (let i = 0; i < index; i++) {
      for (let j = 0; j < 5; j++) {
        const spacingIndex = i * 5 + j;
        position += stripeSpacings[spacingIndex] || baseBeltSpacing / 5;
      }
    }
    
    return position;
  };

  return (
    <>
      {belts.map((belt, index) => {
        const position = getBeltPosition(index);
        
        return (
          <React.Fragment key={index}>
            {/* Track blocker behind belt icon */}
            <div
              className="absolute z-10 bg-card"
              style={{
                left: position,
                top: '50%',
                transform: 'translate(-50%, -50%)',
                width: '80px',  // match belt icon width
                height: '20px', // enough to cleanly block the line
                borderRadius: 0,
              }}
            />
            {/* Belt icon */}
            <div 
              className="absolute transform -translate-x-1/2 top-1/2 -translate-y-1/2 z-20 cursor-pointer hover:scale-105 transition-transform opacity-60 hover:opacity-100 transition-opacity"
              style={{ left: position }}
              onClick={() => onBeltClick && onBeltClick({ ...belt })}
              role="button"
              tabIndex={0}
              aria-label={`${belt.name} belt`}
            >
              <div 
                className="rounded-2xl border-2 border-black flex items-center justify-center text-sm font-medium shadow-md"
                style={{ 
                  backgroundColor: belt.color,
                  color: belt.color === '#000000' ? '#ffffff' : '#000000',
                  height: '80px',
                  width: '80px'
                }}
              >
                {belt.name}
              </div>
            </div>
          </React.Fragment>
        );
      })}
    </>
  );
};
